import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { DataService } from '../../../../services/data.service';
import { ToolOutput } from '../../models/calculationModels/tool-output';
import { DiagramInfo } from '../../models/diagram-info';
import { ToolsData } from '../../models/tools-data';

@Component({
    selector: 'app-tools-input',
    templateUrl: './tools-input.component.html',
    styleUrls: ['./tools-input.component.scss'],
})
export class ToolsInputComponent implements OnInit {
    @Input() isRedirect: boolean;
    @Input() tools: ToolOutput[];
    @Output() nearestObst: EventEmitter<string> = new EventEmitter();
    @Output() selectedTool: EventEmitter<string> = new EventEmitter();
    @Output() diagram: EventEmitter<DiagramInfo> = new EventEmitter();

    nearestObstructionDefault: string = '1000 mm';
    toolSelectedDefault: string;
    toolsFormGroup: UntypedFormGroup;
    toolsData: ToolsData;

    constructor(
        private fb: UntypedFormBuilder,
        private dataSvc: DataService,
        private globallobalEmittersService: GlobalEmittersService
    ) {}

    ngOnInit(): void {
        this.loadFormGroup();

        this.toolsFormGroup = this.fb.group({
            nearestObstruction: [this.nearestObstructionDefault, { updateOn: 'blur', validators: Validators.required }],
            toolSelected: [this.toolSelectedDefault],
        });
        this.toolsFormGroup.markAllAsTouched();
        this.toolsFormGroup.markAsDirty();
        this.toolsFormGroup.get('nearestObstruction').valueChanges.subscribe((value) => this.nearestObst.emit(value));
        this.toolsFormGroup.get('toolSelected').valueChanges.subscribe((value) => this.emitToolSelected(value));

        this.globallobalEmittersService.toolsFormGroup.next(this.toolsFormGroup);
    }

    loadFormGroup() {
        if (this.isRedirect && this.dataSvc.calculationData != null) {
            this.nearestObstructionDefault = this.dataSvc.calculationData.input.calculationOverrides.distanceToNearestObstruction;
            this.toolSelectedDefault = this.dataSvc.calculationData.output.tools?.find((x) => x.isSelected)?.id;
            if (this.toolSelectedDefault) {
                this.emitToolSelected(this.toolSelectedDefault);
            }
        }
    }

    emitToolSelected(toolId: string) {
        this.selectedTool.emit(toolId);
        let selectedTool = this.tools.find((x) => x.id === toolId);

        let diagramInfo = new DiagramInfo();
        diagramInfo.diagramId = selectedTool.diagramId;
        diagramInfo.diagramType = 'Tool Diagram';
        this.diagram.emit(diagramInfo);

        let diagramInfoImage = new DiagramInfo();
        diagramInfoImage.diagramId = selectedTool.imageId;
        diagramInfoImage.diagramType = 'Tool Image';
        this.diagram.emit(diagramInfoImage);
    }
}
